<section>
  <h3>Request Product</h3>
  <hr />
  <div>
    <form [formGroup]="clientAddress">
      <div class="form-group">
        <label for="rp-name">Product Name</label>
        <input id="rp-name" formControlName="name" type="text" class="form-control" />
        <span
          class="text-danger"
          *ngIf="
            clientAddress.controls.name.touched &&
            clientAddress.controls.name.errors?.required
          "
        >
          Name is Required
        </span>
      </div>

      <div class="form-group">
        <label for="rp-url">Product Url</label>
        <input id="rp-url" formControlName="url" type="text" class="form-control" />
      </div>
      <div class="form-group">
        <label for="rp-image">Product Image</label>
        <br />
        <input
          id="rp-image"
          formControlName="image"
          (change)="onFileUpload($event)"
          type="file"
        />
      </div>
      <button (click)="onNoClick()" class="btn">Save</button>
    </form>
  </div>
</section>
